var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"loader"},[_c('v-progress-circular',{staticClass:"spinner",attrs:{"large":"","indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }